import React from "react";
import { Button, Card, Col, Container, Row, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import background from "../assets/logo/logo_transparent.png";
import {
  AddFile,
  Coding,
  DeleteFile,
  HDD,
  Info,
  Lost,
  PhoneLandscape,
  PhonePortrait,
  Picture,
  ThumbsDown,
  ThumbsUp,
} from "../assets/svgs/Icons";
import ButtonWithIcon from "../components/ButtonWithIcon";

export default function Hints() {
  const navigation = useNavigate();

  return (
    <div
      style={{
        maxWidth: "100%",
        backgroundImage: `url(${background})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "80%",
        minHeight: "90vw",
      }}
    >
      <h1
        className="my-5"
        style={{ textAlign: "center", textDecoration: "underline" }}
      >
        Wichtige Hinweise
      </h1>

      <Container className="pt-1">
        <Row xs={1} md={2} lg={3} className="g-5">
          <Col>
            <Card>
              <Card.Header>
                <Stack
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <AddFile />
                  <h3>Artikel erstellen</h3>
                </Stack>
              </Card.Header>
              <Card.Body>
                <ul className="ps-3">
                  <li className="mb-3">
                    Bitte nur Sportartikel einstellen, die mit Fußball und /
                    oder dem ASV zu tun haben.
                  </li>
                  <div className="ps-2 pe-4 d-flex flex-column align-items-center">
                    <ButtonWithIcon
                      variant={"outline-success"}
                      Icon={ThumbsUp}
                      text={
                        "ASV-Klamotten, Fußballschuhe, Bälle, Trikots, etc."
                      }
                      clickable={false}
                    />
                    <p />

                    <ButtonWithIcon
                      variant={"outline-danger"}
                      Icon={ThumbsDown}
                      text={"sonstige nicht ASV-Kleidung"}
                      clickable={false}
                    />
                    <p />
                    <ButtonWithIcon
                      variant={"outline-primary"}
                      Icon={Info}
                      text={
                        "Artikel, die dem oberen Punkt nicht entsprechen, werden gelöscht"
                      }
                      clickable={false}
                    />
                  </div>
                  <li className="my-3">
                    Wenn ihr bei den Kontaktmöglichkeiten eine Sache nicht
                    angeben möchtet (z.B.&nbsp;Telefonnummer), setzt einfach ein
                    beliebiges Füllzeichen (z.B.&nbsp;"-") in das entsprechende
                    Feld.
                  </li>
                  <li className="my-3">
                    Die vom Verkäufer bevorzugte Kontaktmöglichkeit wird im
                    Kontaktfeld immer als erstes angegeben und grün hinterlegt.
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Header>
                <Stack
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <DeleteFile />
                  <h3>Artikel löschen</h3>
                </Stack>
              </Card.Header>
              <Card.Body>
                <ul className="ps-3">
                  <li className="mb-3">
                    Bitte löscht einen Artikel selbständig, sobald dieser
                    verkauft wurde oder nicht mehr zur Verfügung steht.
                  </li>
                  <div className="ps-2 pe-4 d-flex flex-column align-items-center">
                    <ButtonWithIcon
                      variant={"outline-primary"}
                      Icon={Info}
                      text={
                        "Durch das Löschen des Artikels werden alle damit verknüpften Informationen (Name, E-Mail, Telefonnummer, Bilder, etc.) ebenfalls gelöscht."
                      }
                      clickable={false}
                    />
                    <p />
                  </div>
                  <li className="mb-3">
                    Artikel die gelöscht wurden, können nicht wiederhergestellt
                    werden.
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Header>
                <Stack
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <Picture />
                  <h3>Bilder</h3>
                </Stack>
              </Card.Header>
              <Card.Body>
                <ul className="ps-3">
                  <li className="">
                    Bitte achtet darauf die Bilder im <b>Querformat</b>{" "}
                    aufzunehmen, da die Bilder auf ein bestimmtes Format (16:9)
                    zurechtgeschnitten werden.
                  </li>
                  <Stack
                    className="ps-2 pe-4 d-flex flex-row align-items-center"
                    direction="horizontal"
                  >
                    <ButtonWithIcon
                      variant={"outline-success"}
                      Icon={PhoneLandscape}
                      text={"Richtig"}
                      clickable={false}
                    />
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <ButtonWithIcon
                      variant={"outline-danger"}
                      Icon={PhonePortrait}
                      text={"Falsch"}
                      clickable={false}
                    />
                  </Stack>
                  <li className="mb-3">
                    Ihr könnt maximal 5 Bilder pro Artikel hochladen.
                  </li>
                  <li className="mb-3">
                    Die Reihenfolge und Anzahl der Bilder kann im Nachhinein
                    nicht mehr verändert werden. Falls ihr also einen Artikel
                    erstellt habt und danach noch ein Bild hinzufügen oder
                    löschen wollt, müsst ihr den ganzen Artikel nochmal neu
                    erstellen.
                  </li>
                  <div className="ps-2 pe-4 d-flex flex-column align-items-center">
                    <ButtonWithIcon
                      variant={"outline-primary"}
                      Icon={Info}
                      text={
                        "Das zuerst hochgeladene Bild wird auch später als erstes angezeigt."
                      }
                      clickable={false}
                    />
                  </div>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Header>
                <Stack
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <Lost />
                  <h3>Fundsachen</h3>
                </Stack>
              </Card.Header>
              <Card.Body>
                <ul className="ps-3">
                  <li className="mb-3">
                    Hier findet ihr Fundsachen die beim ASV liegen geblieben
                    sind und auf ihren Besitzer warten.
                  </li>
                  <li className="mb-3">
                    Ihr könnt sie zu den Öffnungszeiten der Geschäftsstelle im
                    Keller abholen: <br />
                    <i>(Montag und Donnerstag 15:30 - 18:30 Uhr)</i>
                  </li>
                  <li className="mb-3">
                    Fundstücke, die nach über einem Monat nicht abgeholt wurden,
                    werden verschenkt.
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Header>
                <Stack
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <HDD />
                  <h3>Datenschutz</h3>
                </Stack>
              </Card.Header>
              <Card.Body>
                <ul className="ps-3">
                  <li className="mb-3">
                    Alle Daten werden auf einem Google Server in Frankfurt
                    gespeichert.
                  </li>
                  <li className="mb-3">
                    Das Hosting der Website, Speicherung der Daten,
                    Anmeldevorgang, etc. wird von einem Google Dienst namens{" "}
                    <i>Firebase</i> übernommen.
                  </li>
                  <li className="mb-3">
                    Es werden <b>keine</b> Daten an Drittanbieter weitergegeben
                    und euer Verhalten auf der Website wird auch <b>nicht</b>{" "}
                    analysiert.
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Header>
                <Stack
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ minHeight: "100px" }}
                >
                  <Coding />
                  <h3>Projekt</h3>
                </Stack>
              </Card.Header>
              <Card.Body>
                <ul className="ps-3">
                  <li className="mb-3">
                    Dies ist ein "Ein-Mann-Projekt". Falls ihr also über
                    irgendwelche Fehler stolpert, habt bitte Nachsicht.
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <div className="my-5 d-flex justify-content-center align-items-center">
        <Button onClick={() => navigation("/")}>
          <h1 className="p-2 m-0">Verstanden</h1>
        </Button>
      </div>
    </div>
  );
}
